import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import './TalonRegistrationTranslate';
import {
  talonRegistrationModule,
  loadTableData,
  clearState
} from './TalonRegistrationDucks';
import { talonRegistrationColumns } from './TalonRegistrationColumns';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import { history } from '../../_helpers/history';
import paths from '../../_helpers/paths';

export default function TalonRegistrationPage() {
  const { t, i18n } = useTranslation();
  const { tableData, loadingTable } = useSelector(
    state => state[talonRegistrationModule]
  );
  const dispatch = useDispatch();
  const { nextPage } = useTableFilter(filter => dispatch(loadTableData(filter)));

  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_talonRegistration') }
  ];

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <h3>{t('talonRegistration_title')}</h3>
        <StaticTablePagination
          columns={talonRegistrationColumns({
            t,
            lang: i18n.language,
            onView: id =>
              history.push(paths.talonRegistrationViewPage.replace(':id', id))
          })}
          data={tableData.content}
          sortable={false}
          loading={loadingTable}
          totalElements={tableData.totalElements}
          onClickLoadMore={() => nextPage()}
        />
      </Paper>
    </>
  );
}
